module.exports = __webpack_public_path__ + "static/image5-0cde5dce758ffb01f5516461c54a7c25.jpg";